import React, { useState, useRef, useEffect, useCallback } from "react";
import AgCharts from "../../utilities/AgCharts";
import FuseSvgIcon from "@fuse/core/FuseSvgIcon/FuseSvgIcon";
import FuseAnimate from "@fuse/core/FuseAnimate";
import { Card } from '@mui/material';
import CalendarMain from "../Calendar/Calendar";
import TrainingDashboardFilter from "./TrainingDashboardFilter";
import CustomCalendar from "../Calendar/CalendarCustom";
import ReactApexChart from 'react-apexcharts';
import Typography from '@mui/material/Typography';
import { styled, useTheme } from "@mui/material/styles";
import {
    Box,
    Button,
    FormControl,
    OutlinedInput,
    InputAdornment,
    Grid,
    TextField,
    Tooltip,
} from "@mui/material";
import Chip from '@mui/material/Chip';
import imageOne from "../../../../assets/Ellipse 2404.png";
import imageTwo from "../../../../assets/Ellipse 2405.png";
import imageThree from "../../../../assets/nolte.png";
import tick from "../../../../assets/tick.svg";
import cancel from "../../../../assets/cancel.svg";
import requestData from "./requestMockData.json";
import ToggleButton from '@mui/material/ToggleButton';
import ToggleButtonGroup from '@mui/material/ToggleButtonGroup';
import addIcon from '../../../../assets/add-training.svg';
import RequestForm from "./RequestAddForm";

const StyledOutlinedInput = styled(OutlinedInput)(({ theme }) => ({
    "& input": {
        padding: "10px 14px",
        height: '0.4375em',
    },
    "&.MuiOutlinedInput-root": {
        lineHeight: 1,
        minHeight: '38px',
        borderRadius: '25px'
    }
}));

const CustomToggleButton = styled(ToggleButton)(({ theme }) => ({
    "&.MuiToggleButton-root": {
        lineHeight: 0.75,
        borderRadius: '28px',
        backgroundColor: '#32383E'
    },
    "&.MuiToggleButton-root.Mui-selected": {
        color: 'white',
        background: 'linear-gradient(#57380B, #A06C21)'
    }
}))

const Requests = () => {
    const customChartRef = useRef();

    function formatNumber(value) {
        value /= 100;
        return Math.floor(value)
    }

    const [searchRequests, setSearchRequests] = useState("");
    const [selectedCustomerCode, setSelectedCustomerCode] = useState("Customer Code")
    const [selectedCustomerCodeInfo, setSelectedCustomerCodeInfo] = useState("Customer Code")
    const [showRequestForm, setShowRequestForm] = useState(false);
    const [alignment, setAlignment] = React.useState('customer');

    const handleCustomerCodeChange = (custCode) => {
        setSelectedCustomerCode(custCode);
    }

    const handleCustomerCodeChangeInfo = (custCode) => {
        setSelectedCustomerCodeInfo(custCode);
    }

    const handleAddRequests = () => {
        setShowRequestForm(true);
    }

    const handleToggleChange = (event, newAlignment) => {
        setAlignment(newAlignment);
    }

    const handleClose = () => {
        setShowRequestForm(false);
    }

    return (
        <>
            <div className="w-full sm:w-12/12 px-28">
                <TrainingDashboardFilter hideAddButton={true} handleCustomerCodeChange={handleCustomerCodeChange} />
            </div>
            <div className="p-24">
                <div className="w-full p-24 flex flex-col border-solid border-2 border-rose-400 rounded-3xl">
                    <div className=" w-full flex pr-12 m-10">
                        <div className="sm:w-9/12">
                            <ToggleButtonGroup
                                color="primary"
                                value={alignment}
                                exclusive
                                onChange={handleToggleChange}
                                aria-label="Request"
                            >
                                <CustomToggleButton value="customer">Customer Requests</CustomToggleButton>
                                <CustomToggleButton value="training">Training Requests</CustomToggleButton>
                            </ToggleButtonGroup>
                        </div>
                        {alignment !== "customer" &&
                            <div className="sm:w-3/12 mr-4 cursor-pointer">
                                <FuseAnimate animation="transition.expandIn" delay={500}>
                                    <Tooltip title={"Add Event"}>
                                        <img src={addIcon} width={'25'} height={'auto'} alt="add icon" onClick={handleAddRequests} />
                                    </Tooltip>
                                </FuseAnimate>
                            </div>
                        }
                        <div className="sm:w-3/12 ml-16">
                            <StyledOutlinedInput
                                type="text"
                                name="searchRequests"
                                placeholder="Search Requests"
                                value={searchRequests}
                                onChange={(e) => { setSearchRequests(e.target.value) }}
                                variant="outlined"
                                fullWidth
                                startAdornment={<InputAdornment position="start"><FuseSvgIcon>heroicons-outline:search</FuseSvgIcon></InputAdornment>}
                            />
                        </div>
                    </div>
                    {/* <div className="p-16 mt-5 w-full flex flex-column p-16 rounded-3xl" style={{backgroundColor: "#31363A"}}>
                        <div className="sm:w-1/12">
                            <img src={imageOne} alt="imageOne" width={'80%'} />
                        </div>
                        <div className="sm:w-9/12">
                            <h3 style={{fontSize: '14px',fontWeight: 700, color:'#FFFFFF'}}>Training Requested-Winner Training</h3>
                            <h5>country: UAE 30001</h5>
                            <h5>Month: Decmber</h5>
                        </div>
                        <div className="sm:w-2/12">
                            <Button color="warning" variant="outlined">Add to Forecast</Button>
                        </div>
                    </div> */}
                    {
                        alignment === "customer"
                            ? requestData.requests.map((request, index) => (
                                <div className="p-16 mt-20 w-full flex flex-column p-16 rounded-3xl" style={{ backgroundColor: "#31363A" }}>
                                    <div className="sm:w-1/12">
                                        <img src={imageOne} alt="imageOne" width={'80%'} />
                                    </div>
                                    <div className="sm:w-9/12">
                                        <h3 style={{ fontSize: '14px', fontWeight: 700, color: '#FFFFFF' }}>{request.trainingName}<span style={{ backgroundColor: request.forecasted ? "#499275" : "#b74a3a", fontSize: "8px", padding: "3px 5px", marginLeft: "5px", borderRadius: "4px" }}>{request.forecasted ? "Forecasted" : "NEW"}</span></h3>
                                        <h5>country: {request.country}</h5>
                                        <h5>Month: {request.month}</h5>
                                    </div>
                                    {!request.forecasted &&
                                        <div className="sm:w-2/12 mt-20">
                                            <Button color="warning" variant="outlined" sx={{ borderRadius: "8px" }}>Add to Forecast</Button>
                                        </div>
                                    }
                                </div>
                            )
                            )
                            :
                            requestData.requests.map((request, index) => (
                                <div className="p-16 mt-20 w-full flex flex-column p-16 rounded-3xl" style={{ backgroundColor: "#31363A" }}>
                                    <div className="sm:w-1/12">
                                        <img src={imageThree} alt="imageThree" width={'80%'} />
                                    </div>
                                    <div className="sm:w-7/12">
                                        <h3 style={{ fontSize: '14px', fontWeight: 700, color: '#FFFFFF' }}>{request.trainingName}<span style={{ backgroundColor: request.forecasted ? "#499275" : "#b74a3a", fontSize: "8px", padding: "3px 5px", marginLeft: "5px", borderRadius: "4px" }}>{request.forecasted ? "Forecasted" : "NEW"}</span></h3>
                                        <h5>country: {request.country}</h5>
                                        <h5>Month: {request.month}</h5>
                                    </div>
                                    {!request.forecasted &&
                                        <>
                                            <div className="sm:w-2/12 mt-20">
                                                <Button color="warning" variant="outlined" sx={{ borderRadius: "8px" }}>Add to Forecast</Button>
                                            </div>
                                            <div className="sm:w-1/12 mt-20">
                                                <img src={tick} alt="tick" width={'25%'} />
                                            </div>
                                            <div className="sm:w-1/12 mt-20">
                                                <img src={cancel} alt="cancel" width={'25%'} />
                                            </div>
                                        </>
                                    }
                                </div>
                            ))
                    }
                </div>
            </div>
            {showRequestForm &&
                <RequestForm showRequestForm={showRequestForm} handleClose={handleClose}/>
            }
        </>
    )
}

export default Requests;